import EmployeeInfoMenu from "./EmployeeInfoMenu";

import styles from "../styles/Employee.module.css";
import useHistory from "features/webapp/hook/useHistory";
import { useLocation, useNavigate } from "react-router-dom";
import { FloatButton, Space } from "antd";
import { ReactComponent as ExpenseIcon } from "assets/icon/expenseIconCustom.svg";
import { FileTextOutlined } from "@ant-design/icons";
import { useMemo } from "react";
import useSelection from "antd/es/table/hooks/useSelection";
import { useSelector } from "react-redux";

function EmployeeInfo({ getPage = () => { }, handleMenuChange = () => { } }) {

  return (
    <div className={styles.selector}>
      <EmployeeInfoMenu onChange={handleMenuChange} />
    </div>
  );
}

export default EmployeeInfo;
